import ThemedEmojiPicker from "../../components/ThemedEmojiPicker";
import moment from "moment";
// import { useRef } from "react";

import React, { useEffect, useLayoutEffect, useRef, useState, useMemo, useCallback } from "react";
import { ListRowSkeleton } from "@skeleton";
import axios from "../../API/axios";
import { readAllChat, readSingleChat } from "../../Services/apiService";
import {
  clearProcessedUnreadBatch,
  markChatManuallyUnread,
  clearChatManuallyUnread,
  clearManualUnreadForPartner,
  filterAutoReadableMessages,
  getUnreadIncomingMessages,
  getUnreadSignature,
  markUnreadBatchProcessed,
  normalizeChatList,
  mergeChatListReadStatus,
  markAllSentInOpenChatAsRead,
  isBulkReadAllForOpenChat,
  isIncomingMessage,
  resolvePartnerFromReadHub,
  applyReadAllHubReceipt,
  mergeCachedPartnerReadReceipts,
  cachePartnerSentMessagesRead,
  clearPartnerSentMessagesReadCache,
  syncPartnerReadCacheFromHub,
  applyUnreadReceiptsToChatList,
  logReadReceipt,
  uid,
  acquireReadLock,
  releaseReadLock,
  shouldProcessUnreadBatch,
  isReadReceiptRelevant,
  applyReadReceiptsToChatList,
  toReadReceiptPayload,
  appendReplyChatToChatList,
} from "../../utils/chatReadUtils";
import { onHubEvent, startRealtimeHub } from "../../Services/realtimeHubService";
import ChatInteraction from "./ChatInteraction";
import ChatForwardModal from "./ChatForwardModal";
import MessageReplyQuote from "./MessageReplyQuote";
import {
  attachReplyFieldsToMessage,
  buildReplyApiPayload,
  buildReplyQuoteFromMessage,
  cacheMessageReplyQuote,
  embedReplyInMessage,
  enrichChatWithReplyQuote,
  getDisplayMessageText,
  mergeReplyFieldsFromApi,
  resolveMessageReplyQuote,
} from "../../utils/messageReplyUtils";
import ChatHeader from "./ChatHeader";
import ChatUserDetailsPanel from "./ChatUserDetailsPanel";
import { header, people } from "../../config/imagesLink";
import { Link, useLocation } from "react-router-dom";
import DoneAllSharpIcon from "@mui/icons-material/DoneAllSharp";
import AddReactionSharpIcon from "@mui/icons-material/AddReactionSharp";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import NotificationsToast from "../NotificationsToast";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
//import { useIsFocused, useFocusEffect } from '@react-navigation/stack';
// const RealTime_Hub = `https://localhost:7298/hubs`

const ChatBox = ({ 
	setShow,
	setNoticationData,
	notificationData,
	// ReadAllChat,
	show,
	isShown,
	chatInfoid,
	isLoadingChat,
	chatInfo,
	getChatList,
	allUserChats,
	setAllUserChats,
	setChatList,
	chatList,
	UserId,
	msgId,
	connectionUser,
	getMessageList,
	MessagesCount,
	setMsgId,
	userName,
	archiveMessage,
	getArchivedList,
	activeConversation,
	messageList,
	upsertMessageListItem,
}) => {
	// console.log('RealTime_Hub', RealTime_Hub);
	// console.log("chatInfo...............", chatInfo.msgID);
	// console.log("chatInfo2...............", chatInfoid);
    const language = localStorage.getItem("Lang");

	  const { t } = useTranslation();
	const sessionId = localStorage.getItem("sessionId");
	let location = useLocation();
	const profilPic = localStorage.getItem("profilPic");
	const readmsgId = localStorage.getItem("msgId");
	let chatId = "";
	let chatmessageId = "";
	let isRead = false;
	//************************Reply Message Start  ************************//
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
	const handleEmojiClick = () => {
		setShowEmojiPicker(!showEmojiPicker);
	};
	const handleEmojiClose = () => {
		setShowEmojiPicker(false);
	};

	const footerRef = useRef();
	const chatScrollRef = useRef(null);

	const scrollThreadToLatest = useCallback((behavior = "auto") => {
		const area = chatScrollRef.current;
		const content =
			area?.querySelector?.(".chat-main-content") ||
			footerRef.current?.closest?.(".chat-main-content");
		const canScroll = (el) => {
			if (!el) return false;
			const overflowY = window.getComputedStyle(el).overflowY;
			const scrolls =
				overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay";
			return scrolls && el.scrollHeight - el.clientHeight > 2;
		};
		const target = canScroll(content) ? content : canScroll(area) ? area : null;
		if (!target) return;
		const top = target.scrollHeight;
		if (behavior === "smooth" && typeof target.scrollTo === "function") {
			target.scrollTo({ top, behavior: "smooth" });
		} else {
			target.scrollTop = top;
		}
	}, []);

	useLayoutEffect(() => {
		if (isLoadingChat || !chatList?.length) return undefined;
		scrollThreadToLatest("auto");
		const raf = requestAnimationFrame(() => scrollThreadToLatest("auto"));
		const timers = [50, 200, 450].map((delay) =>
			setTimeout(() => scrollThreadToLatest("auto"), delay)
		);
		return () => {
			cancelAnimationFrame(raf);
			timers.forEach(clearTimeout);
		};
	}, [isLoadingChat, chatList?.length, UserId, scrollThreadToLatest]);

	const [content, setContent] = useState("");
	const [replyToMessage, setReplyToMessage] = useState(null);
	const [forwardingMessage, setForwardingMessage] = useState(null);
	const [isForwarding, setIsForwarding] = useState(false);
	const messageInputRef = useRef(null);
	const pendingReplyQuoteRef = useRef(null);

	const handleReplyMessage = useCallback((message) => {
		setReplyToMessage(message);
		setTimeout(() => {
			messageInputRef.current?.focus();
		}, 0);
	}, []);

	const clearReplyMessage = useCallback(() => {
		setReplyToMessage(null);
	}, []);

	const handleForwardMessage = useCallback((message) => {
		if (!getDisplayMessageText(message?.msg)?.trim()) return;
		setForwardingMessage(message);
	}, []);

	const closeForwardModal = useCallback(() => {
		if (isForwarding) return;
		setForwardingMessage(null);
	}, [isForwarding]);

	const handleForwardToContact = useCallback(async (target) => {
		const text = getDisplayMessageText(forwardingMessage?.msg)?.trim();
		const toUserUid = target?.chatInfo?.toUserUid;
		if (!text || !toUserUid) return;

		const threadMsgId = target?.chatInfo?.msgID;
		const payload = {
			deviceType: "Web",
			sessionId,
			type: 1,
			msg: text,
			langKey: language === "en" ? "" : language,
		};

		setIsForwarding(true);
		try {
			if (threadMsgId) {
				await axios.post("Message/ReplyMessage", {
					...payload,
					msgID: threadMsgId,
				});
			} else {
				await axios.post("Message/InitiateMessage", {
					...payload,
					toUserUid,
				});
			}

			setForwardingMessage(null);
			getMessageList({ forceRefresh: true, silent: true });
		} catch (error) {
			console.error(error);
		} finally {
			setIsForwarding(false);
		}
	}, [forwardingMessage, sessionId, language, getMessageList]);

	const partnerDisplayName = userName || chatInfo?.toUserFullName || "";

	const getReplyQuote = useCallback(
		(item) =>
			resolveMessageReplyQuote(
				item,
				chatList,
				UserId,
				partnerDisplayName,
				t("Notifications.You"),
				localStorage.getItem("userUid")
			),
		[chatList, UserId, partnerDisplayName, t]
	);

	const renderReplyQuote = useCallback(
		(item, isOwned) => {
			if (!item || item.isCompleteDeleted) return null;
			const quote = getReplyQuote(item);
			if (!quote) return null;
			return <MessageReplyQuote quote={quote} isOwnBubble={isOwned} />;
		},
		[getReplyQuote]
	);

	const renderMessageBody = useCallback((rawMsg) => {
		const text = getDisplayMessageText(rawMsg);
		const urlRegex = /(https?:\/\/[^\s]+)/g;

		if (urlRegex.test(text)) {
			const parts = text.split(urlRegex);
			return parts.map((part, index) =>
				urlRegex.test(part) ? (
					<a
						key={index}
						href={part}
						target="_blank"
						rel="noopener noreferrer"
						className="link-style"
					>
						{part}
					</a>
				) : (
					<span key={index}>{part}</span>
				)
			);
		}

		return text;
	}, []);

	const renderMessageBodyWithMentions = useCallback((rawMsg) => {
		const text = getDisplayMessageText(rawMsg);
		const urlRegex =
			/(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?/g;
		const parts = text?.split(urlRegex) ?? [];
		const matches = text ? [...text.matchAll(urlRegex)] : [];

		return parts.map((part, index) => (
			<React.Fragment key={index}>
				{part}
				{matches[index] && (
					<a
						href={
							matches[index][0].startsWith("http")
								? matches[index][0]
								: `http://${matches[index][0]}`
						}
						target="_blank"
						rel="noopener noreferrer"
						className="link-style"
					>
						{matches[index][0]}
					</a>
				)}
			</React.Fragment>
		));
	}, []);

	const hasReplyQuote = useCallback(
		(item) => {
			if (!item || item.isCompleteDeleted) return false;
			return Boolean(getReplyQuote(item)?.text);
		},
		[getReplyQuote]
	);

	const renderMessageMeta = useCallback((item, isOwned) => (
		<div className="message-meta f-10 f-400">
			<Tooltip
				title={
					<p className="text-light">{formatMessageTimeTooltip(item.time)}</p>
				}
				arrow
			>
				<span className="message-time">{formatMessageTime(item.time)}</span>
			</Tooltip>
			{isOwned && item?.isCompleteDeleted !== true && (
				<DoneAllSharpIcon
					className={`material-symbols-sharp msg-read-receipt ${item?.isRead ? "text-read" : ""}`}
					fontSize="inherit"
				/>
			)}
		</div>
	), []);

	const renderMessageBubbleBody = useCallback(
		(item, isOwned) => {
			const isDeletedForEveryone = item.isCompleteDeleted === true;

			return (
				<div className="message-body">
					{!isDeletedForEveryone && renderReplyQuote(item, isOwned)}
					<div className="message-text-row">
						<div className="message-text-content">
							{isDeletedForEveryone
								? item.msg
								: isOwned
									? renderMessageBodyWithMentions(item.msg)
									: renderMessageBody(item.msg)}
						</div>
						{renderMessageMeta(item, isOwned)}
					</div>
				</div>
			);
		},
		[
			renderReplyQuote,
			renderMessageBody,
			renderMessageBodyWithMentions,
			renderMessageMeta,
		]
	);

	const applySentReplyContext = useCallback(
		(message, activeReply) => {
			if (!message) return message;

			const merged = mergeReplyFieldsFromApi(
				message,
				activeReply,
				partnerDisplayName,
				t("Notifications.You")
			);

			const quote = buildReplyQuoteFromMessage(
				activeReply,
				partnerDisplayName,
				t("Notifications.You")
			);

			if (quote && merged.chatID != null) {
				cacheMessageReplyQuote(merged.chatID, quote, UserId);
			}

			return merged;
		},
		[UserId, partnerDisplayName, t]
	);

	const ReplyMessage = async () => {
	const activeReply = replyToMessage;
	const quote = activeReply
		? buildReplyQuoteFromMessage(
				activeReply,
				partnerDisplayName,
				t("Notifications.You")
			)
		: null;
	const outboundMsg = quote ? embedReplyInMessage(content, quote) : content;
	const resolvedMsgId = chatInfo?.msgID || msgId;
	if (!resolvedMsgId) {
		await InitiateMessage();
		return;
	}
	const messageDetails = {
		deviceType: "Web",
		sessionId: sessionId,
		msgID: resolvedMsgId,
		type: 1,
		msg: outboundMsg,
		langKey: language === "en" ? "" : language,
		...buildReplyApiPayload(activeReply),
	};

	try {
		if (activeReply) {
			const quote = buildReplyQuoteFromMessage(
				activeReply,
				partnerDisplayName,
				t("Notifications.You")
			);
			if (quote) {
				pendingReplyQuoteRef.current = quote;
			}
		}

		const response = await axios.post("Message/ReplyMessage", messageDetails);

		const resMsg = response?.data?.responseData;
		const msgDate = moment(resMsg.time).format("YYYY-MM-DD");

		const formattedMsg = applySentReplyContext(
			{
				...resMsg,
				msg: resMsg.msg ?? outboundMsg,
				isOwned: true,
				isDeleted: false,
				isCompleteDeleted: false,
			},
			activeReply
		);

		if (formattedMsg.chatID != null && pendingReplyQuoteRef.current) {
			pendingReplyQuoteRef.current = null;
		}

		setChatList((prev) => {
			const updated = [...prev];
			const dateGroupIndex = updated.findIndex(group => group.msgDate === msgDate);
 
			if (
				dateGroupIndex !== -1 &&
				updated[dateGroupIndex].chats.some(
					(chat) => String(chat.chatID) === String(formattedMsg.chatID)
				)
			) {
				return prev; // Don't add duplicate
			}

			if (dateGroupIndex !== -1) {
				updated[dateGroupIndex].chats.push(formattedMsg);
			} else {
				updated.push({
					msgDate,
					chats: [formattedMsg],
				});
			}
			return updated;
		});

		// getChatList()
		getMessageList({ forceRefresh: true, silent: true });

		setContent("");
		clearReplyMessage();
	} catch (error) {
		console.error(error);
	}
};

	const InitiateMessage = async () => {
	const activeReply = replyToMessage;
	const quote = activeReply
		? buildReplyQuoteFromMessage(
				activeReply,
				partnerDisplayName,
				t("Notifications.You")
			)
		: null;
	const outboundMsg = quote ? embedReplyInMessage(content, quote) : content;
		const messageDetails = {
			deviceType: "Web",
			sessionId: sessionId,
			type: 1,
			msg: outboundMsg,
			toUserUid: UserId,
			      langKey: language === "en" ? "" : language,
			...buildReplyApiPayload(activeReply),

		};

  try {
    const response = await axios.post("Message/InitiateMessage", messageDetails);
    const resMsg = response?.data?.responseData;
    if (!resMsg) return;

    const threadMsgId = resMsg.msgID ?? resMsg.id;
    // Never treat thread msgID/id as chatID — that causes a duplicate empty bubble when ReplyChat arrives
    const chatId = resMsg.chatID ?? resMsg.ChatID ?? null;

    if (activeReply) {
      const quote = buildReplyQuoteFromMessage(
        activeReply,
        partnerDisplayName,
        t("Notifications.You")
      );
      if (quote) {
        pendingReplyQuoteRef.current = quote;
        if (chatId != null) {
          cacheMessageReplyQuote(chatId, quote, UserId);
          pendingReplyQuoteRef.current = null;
        }
      }
    }

    setMsgId(threadMsgId);
    if (threadMsgId != null) {
      localStorage.setItem("msgId", String(threadMsgId));
    }

    const msgDate = moment(resMsg.time || undefined).format("YYYY-MM-DD");
    const formattedMsg = applySentReplyContext(
      {
        ...resMsg,
        msg: resMsg.msg ?? outboundMsg,
        chatID: chatId,
        msgID: threadMsgId,
        time: resMsg.time || moment().toISOString(),
        isOwned: true,
        isDeleted: false,
        isCompleteDeleted: false,
      },
      activeReply
    );

    // Only optimistic-insert when we have a real message chatID; otherwise reload the thread
    if (chatId != null) {
      setChatList((prev) => {
        const updated = Array.isArray(prev) ? [...prev] : [];
        const dateGroupIndex = updated.findIndex((group) => group.msgDate === msgDate);

        if (
          dateGroupIndex !== -1 &&
          updated[dateGroupIndex].chats.some(
            (chat) => String(chat.chatID) === String(formattedMsg.chatID)
          )
        ) {
          return prev;
        }

        if (dateGroupIndex !== -1) {
          updated[dateGroupIndex] = {
            ...updated[dateGroupIndex],
            chats: [...updated[dateGroupIndex].chats, formattedMsg],
          };
        } else {
          updated.push({
            msgDate,
            chats: [formattedMsg],
          });
        }
        return updated;
      });
    } else {
      getChatList?.({ forceRefresh: true });
    }

    setContent("");
    clearReplyMessage();

    upsertMessageListItem?.(UserId, {
      chatID: chatId,
      lastMsg: outboundMsg,
      lastMsgTime: resMsg.time || moment().toISOString(),
      msgID: threadMsgId,
      partnerName: partnerDisplayName,
      partnerImage: chatInfo?.toUserImage,
    });

    getMessageList({ forceRefresh: true, silent: true });

    setTimeout(() => {
      scrollThreadToLatest("smooth");
    }, 200);
  } catch (error) {
    console.log(error);
  }
};
  	
	const handleKeyPress = () => {
		if (content.length > 0) {
			const resolvedMsgId = chatInfo?.msgID || msgId;
			if (resolvedMsgId) {
				ReplyMessage();
			} else {
				InitiateMessage();
			}
		}
	};

	const handleIntiatiateMessage = () => {
		if (content.length > 0) {
			const resolvedMsgId = chatInfo?.msgID || msgId;
			// Existing thread (even with empty history) must use ReplyMessage
			if (resolvedMsgId) {
				ReplyMessage();
			} else {
				InitiateMessage();
			}
		}
	};


	// 	useEffect(() => {
    //   const connection = new HubConnectionBuilder()
	// 	.withUrl(RealTime_Hub, { skipNegotiation: false })
	// 	.withAutomaticReconnect()
	// 	.build();

	// 		connection.start().then(() => { 
			
	// 			connection.on("ReplyChat", (message) => {
	// 				// debugger 
	// 			const userUid = localStorage.getItem("userUid");   
	// 			const openChatUserUid = localStorage.getItem("toUserUid");  
			
	// 			const isRelevantToCurrentChat =
	// 				(message.senderUid === openChatUserUid && message.receiverUid === userUid) ||
	// 				(message.senderUid === userUid && message.receiverUid === openChatUserUid);

	// 			if (!isRelevantToCurrentChat) {
	// 				return;  
	// 			}
			
	// 			message.isDeleted = false;
	// 			message.isCompleteDeleted = false;
	// 			message.isOwned = message.senderUid === userUid;
	// 			message.status = message.isOwned ? "Send" : "";
			
	// 			console.log("Checking ReadChat condition", {
	// 				isOwned: message.isOwned,
	// 				isRead:message.isRead,
	// 				// isOnMessageScreen,
	// 				hasFocus: document.hasFocus(),
	// 				isVisible: !document.hidden
	// 				});
	// 			// if (
	// 			// 	!message.isOwned &&
	// 			// 	window.location.toString().includes('/Message/') &&
	// 			// 	document.hasFocus() &&
	// 			// 	!document.hidden
	// 			// ) {
	// 			// 	message.isRead = true;
	// 			// 	ReadChat();
	// 			// } else {
	// 			// 	message.isRead = false;
	// 			// }

	// 			//  if ((chatId != message.chatID)) {
	// 			// 	chatmessageId = null;
	// 			// 	chatId = message.chatID;

	// 			// 	// if (message.receiverUid == userUid && message.senderUid == openChatUserUid && window.location.toString().includes(location.pathname)) {
	// 			// 	// message.status = "Receive";
	// 			// 	// message.isOwned = false;
	// 			// 	// ReadChat();
	// 			// 	// }
	// 			// 	// else if (message.senderUid == userUid && message.receiverUid == openChatUserUid) {
	// 			// 	// message.status = "Send";
	// 			// 	// message.isOwned = true;
					
	// 			// 	// }

	// 			// 	// Handle incoming message
	// 			// 	if (message.receiverUid === userUid && message.senderUid === openChatUserUid) {
	// 			// 		message.isOwned = false;
	// 			// 		message.isRead = false;

	// 			// 		// Mark as read if user is active in chat
	// 			// 		if (window.location.toString().includes('/Message/') && 
	// 			// 			document.hasFocus() && 
	// 			// 			!document.hidden) {
	// 			// 		message.isRead = true;
	// 			// 		ReadChat();
						
	// 			// 		}
	// 			// 	} else if (message.senderUid === userUid && message.receiverUid === openChatUserUid) {
	// 			// 		message.status = "Send";
	// 			// 		message.isOwned = true;
	// 			// 	}
	// 			// 	if ((message.status != null && message.senderUid == userUid && message.receiverUid == openChatUserUid) || 
	// 			// 	(message.status != null && message.receiverUid == userUid && message.senderUid == openChatUserUid)) {
	// 			// 	setChatList(prevChatList => {
	// 			// 		const updatedChatList = [...prevChatList, message];
	// 			// 		return updatedChatList;
	// 			// 	}); 
	// 			// 	}
	// 			// 	}


    //       if ((chatId != message.chatID)) {
    //         chatmessageId = null;
    //         chatId = message.chatID;

    //         if (message.receiverUid == userUid && message.senderUid == openChatUserUid && 
	// 			window.location.toString().includes(location.pathname)) {
    //           message.status = "Receive";
    //           message.isOwned = false;
    //           ReadChat();
    //         } else if (message.senderUid == userUid && message.receiverUid == openChatUserUid) {
    //           message.status = "Send";
    //           message.isOwned = true;
    //         }
    //         if ((message.status != null && message.senderUid == userUid && message.receiverUid == openChatUserUid) || 
	// 		   (message.status != null && message.receiverUid == userUid && message.senderUid == openChatUserUid)) {
    //           setChatList(prevChatList => {
    //             const updatedChatList = [...prevChatList, message];
    //             return updatedChatList;
    //           });
    //           //chatmessageId=chatId;

    //         }
				
	// 			const msgDate = moment(message.time || new Date()).format("YYYY-MM-DD");

	// 			setChatList((prevList) => {
	// 				const existingIndex = prevList.findIndex(g => g.msgDate === msgDate);

	// 				if (existingIndex !== -1) {
	// 				// Prevent duplicates
	// 				if (prevList[existingIndex].chats.some(chat => chat.chatID === message.chatID)) {
	// 					return prevList;
	// 				}

	// 				const updatedList = [...prevList];
	// 				updatedList[existingIndex] = {
	// 					...updatedList[existingIndex],
	// 					chats: [...updatedList[existingIndex].chats, message],
	// 				};
	// 				return updatedList;
	// 				} else {
	// 				return [...prevList, { msgDate, chats: [message] }];
	// 				}
	// 			});
				 
	// 			// Optionally refresh full chat (only if receiver is me)
	// 			//   if (message.receiverUid === userUid) {
	// 			//     getMessageList();
	// 			//   }
	// 	  	}	}
	// 		);
	// 		}).catch((e) => console.log("Connection failed: ", e));

	// 		return () => {
	// 			connection.stop();
	// 		};
	// 		}, []);

	useEffect(() => {
  let cancelled = false;
  const unsubscribers = [];

  const setupHub = async () => {
    try {
      await startRealtimeHub();
    } catch (e) {
      console.log("Connection failed: ", e);
      return;
    }

    if (cancelled) return;

    unsubscribers.push(onHubEvent("ReplyChat", (message) => {
      const userUid = localStorage.getItem("userUid");
      const openChatUserUid = localStorage.getItem("toUserUid");

      const isRelevantToCurrentChat =
        (message.senderUid === openChatUserUid && message.receiverUid === userUid) ||
        (message.senderUid === userUid && message.receiverUid === openChatUserUid);

      if (!isRelevantToCurrentChat) return;

      const isOwnSent =
        uid(message.senderUid) === uid(userUid) &&
        uid(message.receiverUid) === uid(openChatUserUid);

      if (
        message.receiverUid == userUid &&
        message.senderUid == openChatUserUid &&
        window.location.toString().includes(location.pathname)
      ) {
        ReadChat(message.chatID);
      }

      chatId = message.chatID;

      let enrichedMessage = message;
      if (isOwnSent && pendingReplyQuoteRef.current && message.chatID != null) {
        enrichedMessage = attachReplyFieldsToMessage(
          message,
          pendingReplyQuoteRef.current
        );
        cacheMessageReplyQuote(
          message.chatID,
          pendingReplyQuoteRef.current,
          openChatUserUid
        );
        pendingReplyQuoteRef.current = null;
      }

      const enrichIncoming = (prevList) =>
        enrichChatWithReplyQuote(
          enrichedMessage,
          Array.isArray(prevList) ? prevList : [],
          userName || chatInfo?.toUserFullName || "",
          t("Notifications.You"),
          userUid
        );

      if (isOwnSent) {
        setChatList((prevList) =>
          appendReplyChatToChatList(
            Array.isArray(prevList) ? prevList : [],
            enrichIncoming(prevList),
            userUid,
            userName || chatInfo?.toUserFullName || ""
          )
        );
      } else {
        setChatList((prevList) =>
          appendReplyChatToChatList(
            prevList,
            enrichIncoming(prevList),
            userUid,
            userName || chatInfo?.toUserFullName || ""
          )
        );
      }

      if (setAllUserChats && openChatUserUid) {
        setAllUserChats((prev) => ({
          ...prev,
          [openChatUserUid]: appendReplyChatToChatList(
            prev?.[openChatUserUid] || [],
            enrichIncoming(prev?.[openChatUserUid] || []),
            userUid,
            userName || chatInfo?.toUserFullName || ""
          ),
        }));
      }
    }));

        unsubscribers.push(onHubEvent("ReadChat", (message) => {
          const openChatUserUid = localStorage.getItem("toUserUid");
          const userUid = localStorage.getItem("userUid");

          logReadReceipt("ReadChat", message);

          const partnerUid =
            resolvePartnerFromReadHub(message, userUid) || openChatUserUid;

          if (!isReadReceiptRelevant(message, partnerUid, userUid)) {
            return;
          }

          syncPartnerReadCacheFromHub(message, partnerUid);

          const applyReceipt = (list) =>
            applyReadReceiptsToChatList(list, message, userUid, partnerUid);

          setChatList((prevChatList) => {
            if (!Array.isArray(prevChatList)) return prevChatList;
            const hasChat = prevChatList.some((g) =>
              (g.chats || []).some(
                (c) => String(c.chatID) === String(message.chatID)
              )
            );
            if (!hasChat && uid(openChatUserUid) !== uid(partnerUid)) {
              return prevChatList;
            }
            return applyReceipt(prevChatList);
          });

          if (partnerUid && setAllUserChats) {
            setAllUserChats((prev) => {
              if (!prev?.[partnerUid]) return prev;
              return {
                ...prev,
                [partnerUid]: applyReadReceiptsToChatList(
                  prev[partnerUid],
                  message,
                  userUid,
                  partnerUid
                ),
              };
            });
          }
        }));

		unsubscribers.push(onHubEvent("ReadAllChat", (messages) => {
			const openChatUserUid = localStorage.getItem("toUserUid");
			const userUid = localStorage.getItem("userUid");

			if (!userUid) return;

			logReadReceipt("ReadAllChat", messages);

			setChatList((prevChatList) => {
				const result = applyReadAllHubReceipt({
					hubData: messages,
					userUid,
					openPartnerUid: openChatUserUid,
					chatList: prevChatList,
					allUserChats: null,
				});
				return result.applied ? result.chatList : prevChatList;
			});

          if (setAllUserChats) {
            setAllUserChats((prev) => {
              const result = applyReadAllHubReceipt({
                hubData: messages,
                userUid,
                openPartnerUid: openChatUserUid,
                chatList: null,
                allUserChats: prev,
              });
              return result.applied ? result.allUserChats : prev;
            });
          }
			}));

  };

  setupHub();

		return () => {
      cancelled = true;
      unsubscribers.forEach((unsubscribe) => unsubscribe());
		};
		}, []);

	useEffect(() => {
		clearProcessedUnreadBatch(UserId);
		return () => clearManualUnreadForPartner(UserId);
	}, [UserId]);

	useEffect(() => {
		const timer = setTimeout(async () => {
			const openChatUserUid = localStorage.getItem("toUserUid");
			const userUid = localStorage.getItem("userUid");
			const msgID =
				chatInfo?.msgID ||
				chatInfoid ||
				localStorage.getItem("msgId");

			if (
				isLoadingChat ||
				!UserId ||
				UserId === "All" ||
				!openChatUserUid ||
				!userUid ||
				openChatUserUid !== UserId ||
				!Array.isArray(chatList) ||
				chatList.length === 0
			) {
				return;
			}

			const unread = filterAutoReadableMessages(
				getUnreadIncomingMessages(chatList, UserId, userUid),
				UserId
			);
			if (unread.length === 0) return;

			const signature = getUnreadSignature(unread);
			if (!shouldProcessUnreadBatch(UserId, signature)) return;

			const lockKey =
				unread.length === 1
					? `read:${UserId}:${unread[0].chatID}`
					: `readAll:${UserId}:${msgID}:${signature}`;

			if (unread.length > 1 && !msgID) return;
			if (!acquireReadLock(lockKey)) return;

			try {
				if (unread.length === 1) {
					await readSingleChat(unread[0].chatID);
					setChatList((prevList) => {
						if (!Array.isArray(prevList)) return prevList;
						const targetId = String(unread[0].chatID);
						return prevList.map((group) => ({
							...group,
							chats: (group.chats || []).map((chat) =>
								String(chat.chatID) === targetId
									? { ...chat, isRead: true }
									: chat
							),
						}));
					});
				} else {
					await readAllChat({ toUserUid: UserId, msgID });
					setChatList((prevList) => {
						if (!Array.isArray(prevList)) return prevList;
						return prevList.map((group) => ({
							...group,
							chats: (group.chats || []).map((chat) =>
								isIncomingMessage(chat, UserId, userUid)
									? { ...chat, isRead: true }
									: chat
							),
						}));
					});
				}
				markUnreadBatchProcessed(UserId, signature);
			} catch (error) {
				console.error("Error marking chat as read:", error);
			} finally {
				releaseReadLock(lockKey);
			}
		}, 300);

		return () => clearTimeout(timer);
	}, [UserId, chatList, chatInfo?.msgID, chatInfoid, isLoadingChat]);

	//************************ReadChat Chat ************************//

	// const ReadChat = async () => {
	// 	console.log("ReadChat() called with chatId:", chatId);
		
	// 	// Only proceed if we have a valid chatId
	// 	if (!chatId) return;

	// 	const responseData = {
	// 		deviceType: "Web",
	// 		sessionId: sessionId,
	// 		chatID: chatId,
	// 	};

	// 	try {
	// 		const response = await axios.post(`Message/ReadChat`, responseData);
			
	// 		if (response.data.success) {
	// 			// Update local chat list to mark messages as read
	// 			setChatList(prevList => 
	// 				prevList.map(group => ({
	// 					...group,
	// 					chats: group.chats.map(chat => 
	// 						chat.chatID === chatId
	// 							? { ...chat, isRead: true }
	// 							: chat
	// 					)
	// 				}))
	// 			);

	// 			// Notify other users that message has been read
	// 			if (connectionUser) {
	// 				try {
	// 					await connectionUser.invoke("SendReadReceipt", {
	// 						chatID: chatId,
	// 						receiverUid: chatInfo.toUserUid
	// 					});
	// 				} catch (err) {
	// 					console.error("Failed to send read receipt:", err);
	// 				}
	// 			}
	// 		}
	// 	} catch (e) {
	// 		console.error("Error marking chat as read:", e);
	// 	}
	// };

	const ReadChat = async (targetChatId) => {
	const id = targetChatId || chatId;
	if (!id) return;

	try {
		const response = await readSingleChat(id);

		if (response?.success || response?.status === "Success" || response?.Status === "Success") {
			setChatList((prevList) =>
				applyReadReceiptsToChatList(
					prevList,
					[{ chatID: id }],
					localStorage.getItem("userUid"),
					localStorage.getItem("toUserUid")
				)
			);

			if (connectionUser) {
				try {
					await connectionUser.invoke("SendReadReceipt", {
						chatID: id,
						receiverUid: chatInfo.toUserUid
					});
				} catch (err) {
					console.error("Failed to send read receipt:", err);
				}
			}
			MessagesCount?.({ forceRefresh: true });
		}
	} catch (e) {
		console.error("Error marking chat as read:", e);
	}
};

	//************************ReadChat Chat End  ************************//
	//************************UnReadChat Chat ************************//

	const UnReadChat = async () => {
		const responseData = {
			deviceType: "Web",
			sessionId: sessionId,
			chatID: chatId,
		    langKey: language === "en" ? "" : language,
		};
		try {
			await axios.post(`Message/UnReadChat`, responseData).then((res) => {
				// toast.success(res.data.message);
				//setToastMessage(res.data.message);
				//setShowToast(true);
				//getArchivedList();
				//getMessageList();
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				//setWarningToastMessage(e.response.data.message);
				//setShowWarningToast(true);
			} else {
				//setErrorToastMessage(e.response.data.message);
				//setShowErrorToast(true);
			}
		}
	};

	//************************UnReadChat Chat End  ************************//
	 

	const getDisplayDate = (date) => {
	const today = moment().startOf('day');
	const msgDate = moment(date).startOf('day');

	if (msgDate.isSame(today, 'day')) {
		return "Today";
	} else if (msgDate.isSame(today.clone().subtract(1, 'day'), 'day')) {
		return "Yesterday";
	} else if (msgDate.isAfter(today.clone().subtract(6, 'day'))) {
		return msgDate.format("dddd"); // Monday, Tuesday, etc.
	} else {
		return msgDate.format("DD-MM-YYYY"); // e.g. 12 Jul 2025
	}
};

	const formatMessageTime = (time) =>
		moment.utc(time).local().format("h:mm a");

	const formatMessageTimeTooltip = (time) =>
		moment.utc(time).local().format("DD MMMM YYYY, h:mm a");

	const getUserImage = (image) =>
		!image || image === "" ? people.DefaultProfile : image;

	const handleImageError = (e) => {
		e.target.src = people.DefaultProfile;
	};

	const isBlockedByYou = chatInfo?.isBlockedByYou === true;

	const [showChatSearch, setShowChatSearch] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const [activeSearchIndex, setActiveSearchIndex] = useState(0);
	const [showUserDetails, setShowUserDetails] = useState(false);
	const [partnerPhone, setPartnerPhone] = useState("");

	useEffect(() => {
		setShowChatSearch(false);
		setSearchQuery("");
		setActiveSearchIndex(0);
		setShowUserDetails(false);
		setPartnerPhone("");
	}, [UserId]);

	useEffect(() => {
		if (!chatInfo?.toUserUid) return undefined;

		let cancelled = false;
		axios
			.post("UserProfile/GetUserProfile", {
				deviceType: "Web",
				userUid: chatInfo.toUserUid,
				sessionId,
				langKey: language === "en" ? "" : language,
			})
			.then((response) => {
				if (cancelled) return;
				setPartnerPhone(
					response.data?.responseData?.profileInfo?.phoneNumber || ""
				);
			})
			.catch(() => {
				if (!cancelled) setPartnerPhone("");
			});

		return () => {
			cancelled = true;
		};
	}, [chatInfo?.toUserUid, sessionId, language]);

	const searchMatches = useMemo(() => {
		if (!searchQuery.trim() || !Array.isArray(chatList)) return [];

		const query = searchQuery.trim().toLowerCase();
		const matches = [];

		chatList.forEach((group) => {
			(group?.chats || []).forEach((chat) => {
				if (
					chat?.msg &&
					!chat.isCompleteDeleted &&
					getDisplayMessageText(chat.msg).toLowerCase().includes(query)
				) {
					matches.push(String(chat.chatID));
				}
			});
		});

		return matches;
	}, [chatList, searchQuery]);

	useEffect(() => {
		setActiveSearchIndex(0);
	}, [searchQuery]);

	useEffect(() => {
		if (!searchMatches.length) return;

		const targetId = searchMatches[activeSearchIndex];
		const el = document.querySelector(`[data-chat-id="${targetId}"]`);
		el?.scrollIntoView({ behavior: "smooth", block: "center" });
	}, [activeSearchIndex, searchMatches]);

	const isSearchHighlight = useCallback(
		(chatID) => {
			if (!searchQuery.trim() || !searchMatches.length) return false;
			return String(searchMatches[activeSearchIndex]) === String(chatID);
		},
		[searchQuery, searchMatches, activeSearchIndex]
	);

	const isSearchMatch = useCallback(
		(chatID) => {
			if (!searchQuery.trim()) return false;
			return searchMatches.includes(String(chatID));
		},
		[searchQuery, searchMatches]
	);

	const handleSearchPrev = () => {
		if (!searchMatches.length) return;
		setActiveSearchIndex(
			(prev) => (prev - 1 + searchMatches.length) % searchMatches.length
		);
	};

	const handleSearchNext = () => {
		if (!searchMatches.length) return;
		setActiveSearchIndex((prev) => (prev + 1) % searchMatches.length);
	};

	const getMessageHighlightClass = (chatID) => {
		if (!searchQuery.trim()) return "";
		if (isSearchHighlight(chatID)) return " chat-message-search-active";
		if (isSearchMatch(chatID)) return " chat-message-search-match";
		return "";
	};

	const renderUserDetailsPanel = () => (
		<ChatUserDetailsPanel
			show={showUserDetails}
			onClose={() => setShowUserDetails(false)}
			chatInfo={chatInfo}
			isOnline={activeConversation?.chatInfo?.toUserIsOnline}
		/>
	);

	const renderChatHeader = () => (
		<ChatHeader
			chatInfo={chatInfo}
			activeConversation={activeConversation}
			archiveMessage={archiveMessage}
			getArchivedList={getArchivedList}
			getChatList={getChatList}
			getMessageList={getMessageList}
			setChatList={setChatList}
			msgId={msgId}
			getUserImage={getUserImage}
			handleImageError={handleImageError}
			showSearch={showChatSearch}
			onToggleSearch={() => {
				setShowUserDetails(false);
				setShowChatSearch((prev) => {
					if (prev) setSearchQuery("");
					return !prev;
				});
			}}
			searchQuery={searchQuery}
			onSearchQueryChange={setSearchQuery}
			onSearchClose={() => {
				setShowChatSearch(false);
				setSearchQuery("");
			}}
			searchMatchCount={searchMatches.length}
			onSearchPrev={handleSearchPrev}
			onSearchNext={handleSearchNext}
			showUserDetails={showUserDetails}
			onToggleUserDetails={() => {
				setShowChatSearch(false);
				setSearchQuery("");
				setShowUserDetails((prev) => !prev);
			}}
			phoneNumber={partnerPhone}
		/>
	);

	const renderBlockedMessage = () => (
		<div className="write-message-text d-flex align-items-center justify-content-center py-3">
			<p className="f-12 f-400 text-center mb-0 px-3">
				{t("Newsfeed.Want to continue chat with this user")}{" "}
				<Link to="/settings/blockedUser" className="link-style">
					{t("Newsfeed.Unblock from settings")}
				</Link>
			</p>
		</div>
	);

	return (
		<>
			{/* <NotificationsToast
				id={Date.now()}
				show={show}
				data={notificationData}
				onClose={() => setShow(false)}
			/> */}

			{UserId === "All" ? (
				<img src={header.messageError} width={"100%"} />
			) : (
				<>

					{/* -----------------------------------   Mobile View open ---------------------------  */}

					{chatList.length === 0  ? (
						<div
							className={`${!isShown ? "d-block" : "d-md-block d-none"
								} chat-box-main-container pt-0${showChatSearch ? " chat-search-open" : ""}${showUserDetails ? " contact-panel-open" : ""}${replyToMessage ? " reply-preview-open" : ""}`}
						>
							<div className="chat-thread-pane">
							{renderChatHeader()}

							<div className="chat-box-body">
							<div className="chat-main-content">
								<div className="devide-section d-flex align-items-center justify-content-center mb-4">
									<div className="horizontal-line"></div>
								</div>

								{/* {chatList &&
									chatList?.map((item, index) => {
										console.log("itemchat", item);
										return item.isOwned === false ? (
											<div
												className="messages-cont d-flex align-items-end mb-5 ps-3"
													data-chat-id={item.chatID}
												ref={footerRef}
												key={index}
											>
												<div className="me-1">
													<img
														src={getUserImage(chatInfo?.toUserImage)}
													onError={handleImageError}
														alt=""
														width={30}
														height={30}
														className="chat-msg-avatar"
													/>
												</div>

												<div className="message-box f-10 f-400 me-1">
													<div>
														{(() => {
															const urlRegex = /(https?:\/\/[^\s]+)/g; // Regular expression to detect URLs
															if (urlRegex.test(item.msg)) {
															 	const parts = item.msg.split(urlRegex);
																return parts.map((part, index) =>
																	urlRegex.test(part) ? (
																		<a
																			key={index}
																			href={part}
																			target="_blank"
																			rel="noopener noreferrer"
																			className="link-style"
																		>
																			{part}
																		</a>
																	) : (
																		<span key={index}>{part}</span>
																	)
																);
															}
															return item.msg;
														})()}
													</div>
													<div className="message-time f-10 f-400 text-end">
														<span className=" f-10">
															{moment.utc(item.time).local().format("LT")}
														</span>
													</div>
												</div>
												<div className="">
													<ChatInteraction
														getChatList={getChatList}
														chatId={item.chatID}
														item={item}
														setChatList={setChatList}
														onReplyMessage={handleReplyMessage}
														onForwardMessage={handleForwardMessage}
													/>
												</div>
											</div>
										) : (
											<div
												className="messages-cont self-message d-flex align-items-end mb-3"
												ref={footerRef}
											>
											 <div className="ms-2">
													<img
														src={profilPic}
														alt=""
														width={30}
														height={30}
														className="chat-msg-avatar"
													/>
												</div>
												<div className="message-box  self-message-content f-10 f-400 ms-3 ">
												 	<div>
														{(() => {
															const urlRegex =
																/(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?/g;

															const parts = item.msg?.split(urlRegex) ?? [];
															const matches = item.msg ? [...item.msg.matchAll(urlRegex)] : [];

															return parts.map((part, index) => (
																<React.Fragment key={index}>
																 	{part}

																 	{matches[index] && (
																		<a
																			href={
																				matches[index][0].startsWith("http")
																					? matches[index][0]
																					: `http://${matches[index][0]}`
																			}
																			target="_blank"
																			rel="noopener noreferrer"
																			className="link-style"
																		>
																			{matches[index][0]}
																		</a>
																	)}
																</React.Fragment>
															));
														})()}
													</div>
													<div className="d-flex  align-items-center justify-content-end text-end">
														<div className="message-time f-10 f-400">
															<span className=" f-10">
																{(moment().utc().format("ll") ===
																	moment.utc(item.time).format("ll")) ===
																	true
																	? moment.utc(item.time).local().format("LT")
																	: moment
																		.utc(item.time)
																		.local()
																		.format("DD MMMM YYYY [at] h:mm a")}
															</span>{" "}
															<span>
																{item?.isRead === true && item?.isOwned === true
																	? "seen"
																	: ""}
															</span>{" "}
														</div>
														{item?.isRead === false ? (
															<DoneAllSharpIcon
																className="material-symbols-sharp"
																style={{ width: "15px" }}
															/>
														) : (
															<DoneAllSharpIcon
																className="material-symbols-sharp text-read"
																style={{ width: "15px" }}
															/>
														)}
													</div>
												</div>
												<div className="ms-4 selfChat">
													<ChatInteraction
														getChatList={getChatList}
														chatId={item.chatID}
														item={item}
														setChatList={setChatList}
														onReplyMessage={handleReplyMessage}
														onForwardMessage={handleForwardMessage}
													/>
												</div>
											</div>
										);
									})} */}

									{
									Array.isArray(chatList) &&
									[...chatList]
										.sort((a, b) => new Date(a.msgDate) - new Date(b.msgDate)) // Sort group by latest date first
										.map((group, groupIndex) => {
										const tempSentMsg = JSON.parse(sessionStorage.getItem("tempSentMessage"));

										if (!group || !Array.isArray(group.chats) || group.chats.length === 0) return null;

										const groupDate = moment(group.msgDate).format("YYYY-MM-DD");
										const isTempMsgForThisGroup =
											tempSentMsg && groupDate === tempSentMsg.dateKey;

										const isAlreadyPresent =
											isTempMsgForThisGroup &&
											group.chats.some((msg) => msg.chatID === tempSentMsg.chatID);

										const mergedChats = (isTempMsgForThisGroup && !isAlreadyPresent
											? [...group.chats, tempSentMsg]
											: group.chats
										).sort((a, b) => new Date(a.time) - new Date(b.time)); // Keep time in order

										return (
											<React.Fragment key={groupIndex}>
											{/* Date Divider */}
											<div className="text-center my-3">
												<Tooltip
												title={
													<p className="text-light">
													{moment.utc(group.msgDate).local().format("DD MMMM YYYY")}
													</p>
												}
												arrow
												>
												<span className="chat-date-divider px-3 py-1 rounded  f-10 f-500">
													{/* {moment(group.msgDate).format("DD MMM YYYY")} */}
													 {getDisplayDate(group.msgDate)}
												</span>
												</Tooltip>
											</div>

											{/* Map messages inside the group */}
											{mergedChats.map((item, i) => {
												const isOwned = item.isOwned === true;
												const isDeletedForEveryone = item.isCompleteDeleted === true;

												if (
													searchQuery.trim() &&
													!isDeletedForEveryone &&
													!getDisplayMessageText(item.msg)
														?.toLowerCase()
														.includes(searchQuery.trim().toLowerCase())
												) {
													return null;
												}

												return !isOwned ? (
												<div
													className="messages-cont d-flex align-items-end mb-5"
													data-chat-id={item.chatID}
													ref={footerRef}
													key={item.chatID || i}
												>
													{/* Left message */}
													<div className="chat-msg-avatar-wrap">
													<img
														src={getUserImage(chatInfo?.toUserImage)}
													onError={handleImageError}
														alt=""
														width={30}
														height={30}
														className="chat-msg-avatar"
													/>
													</div>
													<div className={`message-box f-10 f-400${isDeletedForEveryone ? " deleted-message" : ""}${getMessageHighlightClass(item.chatID)}${hasReplyQuote(item) ? " has-reply" : ""}`}>
													{renderMessageBubbleBody(item, false)}
													</div>
													{!isDeletedForEveryone && (
													<div>
													<ChatInteraction
														getChatList={getChatList}
														chatId={item.chatID}
														item={item}
														setChatList={setChatList}
														onReplyMessage={handleReplyMessage}
														onForwardMessage={handleForwardMessage}
													/>
													</div>
													)}
												</div>
												) : (
												<div
													className="messages-cont self-message d-flex align-items-end mb-3"
													data-chat-id={item.chatID}
													key={item.chatID || i}
													ref={footerRef}
												>
													{/* Right message */}
													<div className="chat-msg-avatar-wrap">
													<img
														src={profilPic}
														alt=""
														width={30}
														height={30}
														className="chat-msg-avatar"
													/>
													</div>
													<div className={`message-box self-message-content f-10 f-400${isDeletedForEveryone ? " deleted-message" : ""}${getMessageHighlightClass(item.chatID)}${hasReplyQuote(item) ? " has-reply" : ""}`}>
													{renderMessageBubbleBody(item, true)}
													</div>
													{!isDeletedForEveryone && (
													<div className="selfChat">
													<ChatInteraction
														getChatList={getChatList}
														chatId={item.chatID}
														item={item}
														setChatList={setChatList}
														onReplyMessage={handleReplyMessage}
														onForwardMessage={handleForwardMessage}
													/>
													</div>
													)}
												</div>
												);
											})}
											</React.Fragment>
										);
										})
									}
 

							</div>

							</div>

							{isBlockedByYou ? renderBlockedMessage() : (
								<div className="write-message-text d-flex align-items-center"> 
									<div className="me-2">
										<img
											src={profilPic}
											alt=""
											width={30}
											height={30}
											className="chat-msg-avatar"
										/>
									</div>
									<div className="write-message-cont d-flex justify-content-between me-2 position-relative">
										<input
											type="text"
											placeholder={t("Newsfeed.Write messages down here")}
											value={content}
											className="w-100"
											onChange={(e) => {
												setContent(e.target.value);
											}}
											onKeyPress={(e) =>
												e.key === "Enter" && handleIntiatiateMessage()
											}
										/>
										<div className="icons-cont mt-2 d-flex">
											<AddReactionSharpIcon
												className="material-symbols-sharp me-2"
												onClick={handleEmojiClick}
												style={{ cursor: "pointer" }}
											/>
											<SendSharpIcon
												className="material-symbols-sharp"
												onClick={() => handleIntiatiateMessage()}
												style={{ cursor: "pointer" }}
											/>
										</div>
										{showEmojiPicker && (
											<div className="messageEmoji HuzmessageEmoji">
												<div className="position-relative">
													<ThemedEmojiPicker
														onEmojiClick={(e) => {
															setContent((prev) => prev + e.emoji);
															setShowEmojiPicker(false);
														}}
													/>
													<div
														className="emoji-close"
														onClick={handleEmojiClose}
														style={{ cursor: "pointer" }}
													>
														<CloseSharpIcon className="material-symbols-sharp" />
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
							)}
							</div>
							{renderUserDetailsPanel()}
						</div>
						// -----------------------------------   Mobile View close --------------------------- //

						// -----------------------------------   Desktop View open --------------------------- //

					) : UserId !== "" ? (
						<div
							className={`${!isShown ? "d-block" : "d-md-block d-none"
								} chat-box-main-container pt-0${showChatSearch ? " chat-search-open" : ""}${showUserDetails ? " contact-panel-open" : ""}${replyToMessage ? " reply-preview-open" : ""}`}
						>
							<div className="chat-thread-pane">
							{renderChatHeader()}

							<div className="chat-box-body">
							<div className="chat-scroll-area" ref={chatScrollRef}>
								<div className="chat-main-content">
									{/* <div className="devide-section d-flex align-items-center justify-content-center mb-4">
										<div className="horizontal-line"></div>
									 <div className="horizontal-line"></div>
									</div> */}

									{isLoadingChat ? (
										<ListRowSkeleton className="mt-3" count={4} rowHeight={56} showAvatar />
									) : (
										
									Array.isArray(chatList) &&
									[...chatList]
										.sort((a, b) => new Date(a.msgDate) - new Date(b.msgDate)) // Sort group by latest date first
										.map((group, groupIndex) => {
										const tempSentMsg = JSON.parse(sessionStorage.getItem("tempSentMessage"));

										if (!group || !Array.isArray(group.chats) || group.chats.length === 0) return null;

										const groupDate = moment(group.msgDate).format("YYYY-MM-DD");
										const isTempMsgForThisGroup =
											tempSentMsg && groupDate === tempSentMsg.dateKey;

										const isAlreadyPresent =
											isTempMsgForThisGroup &&
											group.chats.some((msg) => msg.chatID === tempSentMsg.chatID);

										const mergedChats = (isTempMsgForThisGroup && !isAlreadyPresent
											? [...group.chats, tempSentMsg]
											: group.chats
										).sort((a, b) => new Date(a.time) - new Date(b.time)); // Keep time in order

										return (
											<React.Fragment key={groupIndex}>
											{/* Date Divider */}
											<div className="text-center my-3">
												<Tooltip
												title={
													<p className="text-light">
													{moment.utc(group.msgDate).local().format("DD MMMM YYYY")}
													</p>
												}
												arrow
												>
												<span className="chat-date-divider px-3 py-1 rounded   f-10 f-500">
													{/* {moment(group.msgDate).format("DD MMM YYYY")} */}
													 {getDisplayDate(group.msgDate)}

												</span>
												</Tooltip>
											</div>

											{/* Map messages inside the group */}
											{mergedChats.map((item, i) => {
												const isOwned = item.isOwned === true;
												const isDeletedForEveryone = item.isCompleteDeleted === true;

												if (
													searchQuery.trim() &&
													!isDeletedForEveryone &&
													!getDisplayMessageText(item.msg)
														?.toLowerCase()
														.includes(searchQuery.trim().toLowerCase())
												) {
													return null;
												}

												return !isOwned ? (
												<div
													className="messages-cont d-flex align-items-end mb-5"
													data-chat-id={item.chatID}
													ref={footerRef}
													key={item.chatID || i}
												>
													{/* Left message */}
													<div className="chat-msg-avatar-wrap">
													<img
														src={getUserImage(chatInfo?.toUserImage)}
													onError={handleImageError}
														alt=""
														width={30}
														height={30}
														className="chat-msg-avatar"
													/>
													</div>
													<div className={`message-box f-10 f-400${isDeletedForEveryone ? " deleted-message" : ""}${getMessageHighlightClass(item.chatID)}${hasReplyQuote(item) ? " has-reply" : ""}`}>
													{renderMessageBubbleBody(item, false)}
													</div>
													{!isDeletedForEveryone && (
													<div>
													<ChatInteraction
														getChatList={getChatList}
														chatId={item.chatID}
														item={item}
														setChatList={setChatList}
														onReplyMessage={handleReplyMessage}
														onForwardMessage={handleForwardMessage}
													/>
													</div>
													)}
												</div>
												) : (
												<div
													className="messages-cont self-message d-flex align-items-end mb-3"
													data-chat-id={item.chatID}
													key={item.chatID || i}
													ref={footerRef}
												>
													{/* Right message */}
													<div className="chat-msg-avatar-wrap">
													<img
														src={profilPic}
														alt=""
														width={30}
														height={30}
														className="chat-msg-avatar"
													/>
													</div>
													<div className={`message-box self-message-content f-10 f-400${isDeletedForEveryone ? " deleted-message" : ""}${getMessageHighlightClass(item.chatID)}${hasReplyQuote(item) ? " has-reply" : ""}`}>
													{renderMessageBubbleBody(item, true)}
													</div>
													{!isDeletedForEveryone && (
													<div className="selfChat">
													<ChatInteraction
														getChatList={getChatList}
														chatId={item.chatID}
														item={item}
														setChatList={setChatList}
														onReplyMessage={handleReplyMessage}
														onForwardMessage={handleForwardMessage}
													/>
													</div>
													)}
												</div>
												);
											})}
											</React.Fragment>
										);
										})
									)
									}
									<div className="chat-messages-end-spacer" aria-hidden="true" />
									<div ref={footerRef}></div>

								</div>
							</div>
							</div>

							{isBlockedByYou ? renderBlockedMessage() : (
							<div className={`write-message-text d-flex flex-column${replyToMessage ? " has-reply" : ""}`}>
							{replyToMessage ? (
								<div className="chat-reply-preview">
									<div className="chat-reply-preview-content">
										<div className="chat-reply-preview-name f-12">
											{replyToMessage.isOwned ? t("Notifications.You") : (userName || chatInfo?.toUserFullName)}
										</div>
										<div className="chat-reply-preview-text f-12">
											{getDisplayMessageText(replyToMessage.msg)}
										</div>
									</div>
									<CloseSharpIcon
										className="chat-reply-preview-close material-symbols-sharp"
										onClick={clearReplyMessage}
									/>
								</div>
							) : null}
							<div className="write-message-row d-flex align-items-center">
								<div className="me-2">
									<img
										src={profilPic}
										alt=""
										width={40}
										height={40}
										className="chat-msg-avatar"
									/>
								</div>
								<div className="write-message-cont d-flex justify-content-between me-2 pb-2 position-relative">
									<input
										type="text"
										ref={messageInputRef}
										placeholder={t("Newsfeed.Write messages down here")}
										className="w-100"
										value={content}
										onChange={(e) => {
											setContent(e.target.value);
										}}
										onKeyPress={(e) => e.key === "Enter" && handleKeyPress()}
									/>
									<div className="icons-cont mt-2 d-flex">
										<AddReactionSharpIcon
											className="material-symbols-sharp me-2"
											onClick={handleEmojiClick}
											style={{ cursor: "pointer" }}
										/>
										<SendSharpIcon
											className="material-symbols-sharp"
											onClick={() => handleKeyPress()}
											style={{ cursor: "pointer" }}
										/>
									</div>
									{showEmojiPicker && (
										<div className="messageEmoji HuzmessageEmoji">
											<div className="position-relative">
												<ThemedEmojiPicker
													onEmojiClick={(e) => {
														setContent((prev) => prev + e.emoji);
														setShowEmojiPicker(false);
													}}
												/>
												<div
													className="emoji-close"
													onClick={handleEmojiClose}
													style={{ cursor: "pointer" }}
												>
													<CloseSharpIcon className="material-symbols-sharp" />
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
							</div>
							)}
							</div>
							{renderUserDetailsPanel()}
						</div>
					) : (
						""
					)}
					{/*  -----------------------------------   Desktop View close  --------------------------- */}
				</>
			)
			}

			<ChatForwardModal
				show={Boolean(forwardingMessage)}
				onClose={closeForwardModal}
				messageList={messageList}
				currentUserId={UserId}
				message={forwardingMessage}
				onForward={handleForwardToContact}
				isForwarding={isForwarding}
			/>
		</>
	);
};

export default ChatBox;
